import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, DatePicker, Select } from 'components';
import { Globals, checkPermission, Constants, Colors } from 'utils';
import { CorporatePaymentService } from 'services';
import { CleanIcon, TrashWhiteIcon, AddWhiteIcon, ConfirmIcon, StarIcon, EditIcon, TrashIcon, ChangeStatusIcon, ViewIcon } from 'assets/icons';
import CreateCorporatePayment from './create-corporate-payment';
import moment from 'moment';
import ModalView from './modal-view';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: '',
	status: ''
}

class CorporatePayments extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'',
			'Nº Orden',
			'Cliente',
			'Tipo',
			'Fecha y Hora',
			'Servicio',
			'Superficie',
			'Estatus del Pago',
			'Acciones'
		],
		visible: false,
		payment_methods: [],
		visible_view: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Control de Pagos Citas Corporativo',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
		this.loadPaymentMethods();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await CorporatePaymentService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.quotes.rows,
			last_page: res.quotes.count
		});
	}

	loadPaymentMethods = async () => {
		const res: any = await CorporatePaymentService.admin.getPaymentMethods({
			withoutLoading: true
		});
		this.setState({
			payment_methods: res.payment_methods
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	getPaymentColor = (service: any) => {
		switch(service.status_payment) {
			case Constants.QUOTE_PAYMENT_STATUS.PENDING:
				return Colors.yellow;
			break;

			case Constants.QUOTE_PAYMENT_STATUS.APPROVED:
				return Colors.green;
			break;
		}
	}

	setActive = (index: number) => {
		let data: any = [...this.state.data];
		data[index].active = !data[index].active;
		this.setState({
			data
		});
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = (reload: boolean = false) => {
		this.setState({
			visible: false
		},() => {
			if (reload) {
				this.load(true);
			}
		});
	}

	view = (e: any,item: any) => {
		e.preventDefault();
		this.setState({
			visible_view: true,
			item
		});
	}

	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		});
	}
	
	render() {
		const { visible, visible_view } = this.state;

		return (
			<div id="admin-corporate-payments">
				<BackComponent />

				<Modal
		          className="modal-view-corporate-payment"
		          visible={ visible_view }
		          title="Ver pago"
		          centered
		          onClose={ () => this.onCloseView() }
		        >
		        	<ModalView
		        		onClose={ () => this.onCloseView() }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

				<Modal
		          className="create-corporate-payments"
		          visible={ visible }
		          title=""
		          centered
		          onClose={ (reload: boolean = false) => this.onClose(reload) }
		        >
		        	<CreateCorporatePayment
		        		onClose={ (reload: boolean = false) => this.onClose(reload) }
		        		payment_methods={ this.state.payment_methods }
		        		quotes={ this.state.data.filter((i: any) => i.active) }
		        	/>
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-9">
						<div className="row">
							<div className="col-md-10 row">
								<div className="col-md-3">
									<Input
										searchLeft
										value={ this.state.form.search }
										name="search"
										placeholder="Nombre"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md-3">
									<DatePicker
										placeholder="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md-3">
									<DatePicker
										placeholder="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
								<div className="col-md-3">
									<Select
										placeholder="Estatus"
										name="status"
										onChange={ (e: any) => this.change(e,() => {
											this.load(true);
										}) }
										value={ this.state.form.status }
										options={ [
											{ value: Constants.QUOTE_PAYMENT_STATUS.PENDING.toString(), label: 'Pendientes' },
											{ value: Constants.QUOTE_PAYMENT_STATUS.APPROVED.toString(), label: 'Pagadas' },
										] } />
								</div>
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-3 text-right">
						{
							this.state.data.filter((i: any) => i.active).length > 0 && checkPermission(Constants.MODULES.CORPORATE_PAYMENTS,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									Registrar pago
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>
									{
										i.status_payment == Constants.QUOTE_PAYMENT_STATUS.PENDING && checkPermission(Constants.MODULES.CORPORATE_PAYMENTS,'delete') && (
											<CheckboxTable 
												active={ i.active } 
												onClick={ () => this.setActive(index) } />
										)
									}
								</td>
								<td>{ i.number }</td>
								<td>{ i.user?.full_name || '-' }</td>
								<td>{ i.type?.name }</td>
								<td className={ i.type_id == Constants.QUOTE_TYPES.URGENT ? 'urgent' : '' }>{ i.type_id == Constants.QUOTE_TYPES.URGENT ? ('Urgente ' + moment(i.date).format('DD/MM/YYYY')) : moment(i.date).format('DD/MM/YYYY') } { moment(i.journey?.since,'HH:mm:ss').format('HH:mm') } - { moment(i.journey?.until,'HH:mm:ss').format('HH:mm') }</td>
								<td>{ i.service?.name }</td>
								<td>{ i.area }</td>
								<td>
									<p className="container-color" style={{
										color: this.getPaymentColor(i)
									}}>
										{ i.corporate_status_payment_text }
									</p>
								</td>
								<td>
									{
										i.status_payment == Constants.QUOTE_PAYMENT_STATUS.APPROVED && i.corporate_payment_quote ? (
											<Tooltip title="Ver">
												<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,i) }>
													<img src={ ViewIcon } />
												</a>
											</Tooltip>
										) : (
											<React.Fragment>
												-
											</React.Fragment>
										)
									}
								</td>
							</tr>		
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(CorporatePayments);